/* CALMEA staggered blur-in reveal.

   Two paths:
   1. Snippet-rendered elements (data-cal-blur). Segments are in the server
      HTML. Elements with trigger="load" arm themselves inline, before first
      paint, so there is no flash; elements with trigger="observe" are armed
      here and revealed by a single shared IntersectionObserver.
   2. Headings inside Craft-owned sections we do not render ourselves. Those
      stay plain text on the server and are split here, purely as decoration.
      Crawlers and no-JS visitors always get the real heading text.

   Arming is what hides the text, and arming only ever happens in JS, so any
   failure in this file leaves every headline visible. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Headings rendered by Craft sections; split client-side only.
  var AUTO = [
    '[id$="__calmea_strips"] h2',
    '[id$="__calmea_scroll_story"] h2',
    '[id$="__calmea_how"] h2',
    '[id$="__calmea_learn"] h2'
  ];

  var observer = null;

  function show(el) {
    el.classList.add('is-in');
  }

  function getObserver() {
    if (observer) return observer;
    if (!('IntersectionObserver' in window)) return null;
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          show(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { threshold: 0.1 }
    );
    return observer;
  }

  function splitWords(el, stagger) {
    if (el.querySelector('.cal-blur__seg')) return;
    var text = (el.textContent || '').replace(/\\s+/g, ' ').trim();
    if (!text) return;

    var words = text.split(' ');
    var frag = document.createDocumentFragment();
    for (var i = 0; i < words.length; i++) {
      var seg = document.createElement('span');
      seg.className = 'cal-blur__seg';
      seg.style.setProperty('--cal-blur-i', String(i));
      seg.setAttribute('aria-hidden', 'true');
      seg.textContent = words[i];
      frag.appendChild(seg);
      if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
    }

    el.setAttribute('aria-label', text);
    el.textContent = '';
    el.appendChild(frag);
    el.classList.add('cal-blur');
    el.setAttribute('data-cal-blur', '');
    el.setAttribute('data-cal-blur-dir', 'top');
    el.style.setProperty('--cal-blur-stagger', (stagger || 60) + 'ms');
  }

  function arm(el) {
    if (el.getAttribute('data-cal-blur-ready') === 'true') return;
    el.setAttribute('data-cal-blur-ready', 'true');
    el.classList.add('is-armed');
    var io = getObserver();
    if (!io) {
      show(el);
      return;
    }
    io.observe(el);
  }

  function init(scope) {
    if (REDUCE.matches) return;
    var root = scope || document;

    for (var i = 0; i < AUTO.length; i++) {
      var found = root.querySelectorAll(AUTO[i]);
      for (var j = 0; j < found.length; j++) {
        splitWords(found[j], 60);
        arm(found[j]);
      }
    }

    var els = root.querySelectorAll('[data-cal-blur][data-cal-blur-trigger="observe"]');
    for (var k = 0; k < els.length; k++) arm(els[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function () {
    init(document);
  });
})();